module.exports = __webpack_public_path__ + "media/images/alf_empty-ba8a153b800f9cda1890da18965ad9a6.svg";